import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Capacitor } from '@capacitor/core'
import { App as CapApp } from '@capacitor/app'
import './index.css'
import App from './App.tsx'
import { supabase } from './lib/supabase'
import { registerPushNotifications } from './lib/push-notifications'
import { scheduleSentryLoad } from './lib/sentry'
import ErrorBoundary from './components/ErrorBoundary'

scheduleSentryLoad()

if (Capacitor.isNativePlatform()) {
  CapApp.addListener('appUrlOpen', ({ url }) => {
    const parsed = new URL(url)
    const code = parsed.searchParams.get('code')
    if (code) {
      supabase.auth.exchangeCodeForSession(url)
    }
  })

  // The app loads its code from the web at launch, but iOS can keep a
  // suspended app alive for days, so a user who never force-quits would
  // stay on whatever was deployed when they last opened it. When the app
  // returns to the foreground after a long gap, reload to pick up the
  // current deployment (and the current day).
  const STALE_AFTER_MS = 6 * 60 * 60 * 1000
  const loadedAt = Date.now()
  CapApp.addListener('appStateChange', ({ isActive }) => {
    if (isActive && Date.now() - loadedAt > STALE_AFTER_MS) {
      window.location.reload()
    }
  })
}

supabase.auth.onAuthStateChange((event, session) => {
  if ((event === 'SIGNED_IN' || event === 'INITIAL_SESSION') && session?.user) {
    registerPushNotifications(session.user.id)
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
